// extracted by mini-css-extract-plugin
module.exports = {"actions":"ActionButtons_actions__Ku3EY","signInButton":"ActionButtons_signInButton__qsu9u","registerButton":"ActionButtons_registerButton__NPvYw"};